import React from 'react';
import PropTypes from 'prop-types';

//MUI
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

//BIKENTA

//UTILS
import {BIOMASS_CO2_FORM_MONITORING, BIOMASS_CO2_FORM_PLANNING} from '../../../../config';
import {useTranslation} from 'react-i18next';
import {projectSummary} from '../../../proptypes/projectSummary';

//STYLES
const containerSx = {
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
  justifyContent: 'space-between'
};

const BiomasCO2Menu = ({
  isOffline,
  interventionZoneId,
  projectSummary,
  onBiomasCO2Open,
  onGetExpostProject,
  onGetExanteProject
}) => {

  const {t} = useTranslation();

  return <Box sx={containerSx}>
    <Button variant='contained' color='secondary' sx={{mt: 2, width: '250px'}} 
      disabled={isOffline} 
      onClick={() => {
        onGetExanteProject(interventionZoneId);
        onBiomasCO2Open(BIOMASS_CO2_FORM_PLANNING);
      }}
    >
      {t('Planificación')}
    </Button>
    <Button variant={projectSummary? 'contained' : 'outlined'} color='secondary' sx={{mt: 2, width: '250px'}}
      disabled={!projectSummary || isOffline}
      onClick={() => {
        onGetExpostProject(interventionZoneId);
        onGetExanteProject(interventionZoneId);
        onBiomasCO2Open(BIOMASS_CO2_FORM_MONITORING);
      }}
    >
      {t('Seguimiento')}
    </Button>
  </Box>;
};

export default BiomasCO2Menu;

BiomasCO2Menu.propTypes = {
  isOffline: PropTypes.bool,
  interventionZoneId: PropTypes.number.isRequired,
  projectSummary: projectSummary,
  onBiomasCO2Open: PropTypes.func,
  onGetExpostProject: PropTypes.func,
  onGetExanteProject: PropTypes.func
};